export default "__VITE_ASSET__D4z8FfxF__"